module.exports = __webpack_public_path__ + "static/media/chopin-footer-3-en.8bf0306b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chopin-footer-3-en.png
// module id = 1094
// module chunks = 0